import ShopaholicSearch from '../../../../js/shopaholic-search';

export default new class SearchDesktop {
  constructor() {
    this.searchResultWrapper = 'search-panel-desktop__result';
    this.searchInputSelector = 'search-panel-desktop__input-field';
    this.searchBtnSelector = 'search-panel-desktop__close';
    this.searchCloseSelector = 'search-panel-desktop__result_hidden';
    this.navbarItems = 'header-contacts__list';
    this.hiddenClass = 'header__info_hidden';
    this.expandClass = 'search__input_full-width';
    this.searchWrapperClass = 'header-middle__search';
    this.searchCloseButton = 'search-panel-desktop__close';

    this.init();
    this.handler();
  }

  init() {
    this.obSearchHelper = new ShopaholicSearch();
    this.obSearchHelper.setAjaxRequestCallback((obRequest) => {
      /* eslint-disable no-param-reassign */
      obRequest.update = { 'header/search/search-panel-desktop/search-panel-desktop-result': `.${this.searchResultWrapper}` };
      /* eslint-enable */

      return obRequest;
    });


    this.obSearchHelper.init();
  }

  handler() {
    const searchInput = document.querySelector(`.${this.searchInputSelector}`);
    const searchResult = document.querySelector(`.${this.searchResultWrapper}`);
    const navbarItems = document.querySelector(`.${this.navbarItems}`);
    const searchWrapper = document.querySelector(`.${this.searchWrapperClass}`);
    const searchClose = document.querySelector(`.${this.searchCloseButton}`);

    searchInput.addEventListener('focus', () => {
      searchResult.classList.remove(`${this.searchCloseSelector}`);
      searchWrapper.classList.add(`${this.expandClass}`);
      navbarItems.classList.add(`${this.hiddenClass}`);
      searchClose.classList.remove(`${this.hiddenClass}`);
    });

    searchInput.addEventListener('blur', () => {

    });

    searchClose.addEventListener('click', () => {
      navbarItems.classList.remove(`${this.hiddenClass}`);
      searchWrapper.classList.remove(`${this.expandClass}`);
      searchResult.classList.add(`${this.searchCloseSelector}`);
      searchClose.classList.add(`${this.hiddenClass}`);
      setTimeout(() => {
        searchResult.classList.add(`${this.searchCloseSelector}`);
      }, 200);
    });

    searchInput.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    });
  }

  clearSearchInput() {
    $(`.${this.searchInputSelector}`).val('');

    const searchResultWrapper = $(`.${this.searchResultWrapper}`);

    const childrenNode = searchResultWrapper.children();

    if (!childrenNode.length) return;

    childrenNode.remove();
  }
}();
